import React, { useState, useEffect, useRef } from "react";
import style from "./NewLearningDetail.module.css";
import LeftArrow from "../../assests/LeftArrow.png";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { baseurl } from "../Url";
import Loader from "../Loder/Loader";
import { useSelector } from "react-redux";
import { FaPlay } from "react-icons/fa";
import { IoChevronDownOutline } from "react-icons/io5";
import { IoChevronUpOutline } from "react-icons/io5";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdKeyboardArrowRight } from "react-icons/md";
import flashCardImg from "../../assests/flashCardImg.png"
import flashimg from "../../assests/ew_flashcard.png"
import { RiArrowRightSLine } from "react-icons/ri";
import { Alert, Snackbar } from "@mui/material";

const NewLearningDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const state = location.state;
  const Topic = state?.singleTopic;
  const learning_id = state?.learning;
  const admin_Mapped_Lessons = state?.mapped;
  const main_topic_id = state?.mainId;
  const topicNo = state?.topic_no;
  const userID = state?.userID;
  const orgID = state?.orgID;
  const expandedModuleIndices = state?.expandedModuleIndices;
  const scrollToModuleIndex = state?.scrollToModuleIndex;
  const scrollToPageNum = state?.scrollToPageNum;
  const scrollToUniqueId = state?.scrollToUniqueId;

  const practiceBtnRefs = useRef({});
  const hasScrolledToPractice = useRef(false);

  const { userDetails, status: userStatus } = useSelector(
    (state) => state.user
  );

  const [AiId, setAiID] = useState("");
  const [topicData, setTopicData] = useState({});
  const [assessmentData, setAssessmentData] = useState({});
  const [loading, setLoading] = useState(true);
  const [trialUser, setTrailUser] = useState(false);
  const [assessmentExist, setAssessmentExist] = useState(false);
  const [expandedPages, setExpandedPages] = useState({});

  const [flashCardButton, setFlashCardButton] = useState([]); 
  const [flashDescription, setFlashDescription] = useState(false); 
  const [flashCard, setFlashCard] = useState(false); 
  const [flipped, setFlipped] = useState(false); 
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [flashInputValues, setFlashInputValues] = useState({});
  const [flashInputErrors, setFlashInputErrors] = useState({});
  const [flashInputResults, setFlashInputResults] = useState({});
  const [snack, setSnack] = useState({ open: false, message: "" });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const cardsToRender = isMobile
    ? flashCardButton[currentIndex]
      ? [{ card: flashCardButton[currentIndex], realIndex: currentIndex }]
      : []
    : flashCardButton
        .map((card, index) => ({ card, realIndex: index }))
        .filter(({ realIndex }) => Math.abs(realIndex - currentIndex) <= 2);

 const cleanHtml = (html) => {
  return String(html || "").replace(
    /<div class="OutlineElement[^>]*>\s*&nbsp;\s*<\/div>/gi,
    "<br/>"
  );
};

  const normalizeAnswer = (value) =>
    String(value || "")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

  const escapeHtml = (value) =>
    String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const buildInputResultHtml = ({
    isCorrect,
    userAnswer,
    correctAnswer,
    descriptionHtml = "",
  }) => {
    if (isCorrect) {
      return `
        <div class="${style.inputResultWrap}">
          <div class="${style.inputResultCorrect}">Correct!</div>
          ${descriptionHtml ? `<div class="${style.inputResultDescNoLine}">${descriptionHtml}</div>` : ""}
        </div>
      `;
    }

    return `
      <div class="${style.inputResultWrap}">
        <div class="${style.inputResultWrong}">Not quite.</div>
        <div class="${style.inputResultLine}">
          <span class="${style.inputResultLabel}">Correct answer:</span>
          <span class="${style.inputResultValue}">${escapeHtml(correctAnswer) || "-"}</span>
        </div>
        ${descriptionHtml ? `<div class="${style.inputResultDesc}">${descriptionHtml}</div>` : ""}
      </div>
    `;
  };

  // ✅ Modal states
  const [showVideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoPlaybackFailed, setVideoPlaybackFailed] = useState(false);

  // ✅ Video Modal Component
  const VideoModal = () => {
    const getEmbedUrl = (url) => {
      if (!url) return "";
      const youtubeMatch = url.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^\s&]+)/
      );
      if (youtubeMatch && youtubeMatch[1]) {
        return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
      }
      return url;
    };

    const isYouTubeLink =
      videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");

    const handleVideoError = () => {
      console.log("Video playback failed, falling back to iframe");
      setVideoPlaybackFailed(true);
    };

    const handleVideoLoad = () => {
      // Reset the fallback state when video loads successfully
      setVideoPlaybackFailed(false);
    };

    const handleCloseModal = () => {
      setShowVideo(false);
      setVideoPlaybackFailed(false); // Reset fallback state when closing
    };

    return (
      <div className={style.videoModalOverlay}>
        <div className={style.videoModalContent}>
          <button
            className={style.closeBtn}
            onClick={handleCloseModal}
          >
            ✕
          </button>
          {isYouTubeLink ? (
            <iframe
              width="100%"
              height="400px"
              src={getEmbedUrl(videoUrl)}
              title="Practice Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : videoPlaybackFailed ? (
            // Fallback to iframe when video fails to play
            <iframe
              width="100%"
              height="400px"
              src={videoUrl}
              title="Practice Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <video 
              controls 
              width="100%" 
              height="auto"
              onError={handleVideoError}
              onLoadedData={handleVideoLoad}
              onCanPlay={handleVideoLoad}
            >
              <source src={videoUrl} type="video/mp4" />
              <source src={videoUrl} type="video/webm" />
              <source src={videoUrl} type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </div>
    );
  };

  async function Topic_Single() {
    await fetch(`${baseurl}/ai/lesson/generation/for/user`, {
      method: "POST",
      body: JSON.stringify({
        Organization_ID: orgID,
        topic_id: Topic.id,
        topic_name: Topic.value,
        learning_id: learning_id,
        main_topic_id: main_topic_id,
        user_id: userID,
        admin_mapped: admin_Mapped_Lessons,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAiID(data.data[0]?.ai_id);
        if (data.data[0]?.assessments?.length > 0) {
          setAssessmentExist(true);
        } else {
          setAssessmentExist(false);
        }
      });
  }

  async function dataGet() {
    if (!AiId) return;

    await fetch(`${baseurl}/lesson/pages-v2`, {
      method: "POST",
      body: JSON.stringify({
        Organization_ID: userDetails && userDetails.org_id,
        ai_id: AiId,
        user_id: userDetails && userDetails._id?.$oid,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setTopicData(data.data?.[0] || {});
        } else {
          setTopicData({});
        }
        setTimeout(() => setLoading(false), 100);
      });
  }
const nextCard = () => {
    setFlipped(false);
    if (!Array.isArray(flashCardButton) || flashCardButton.length === 0) return;
    setCurrentIndex((prev) => (prev + 1) % flashCardButton.length);
  };

  const prevCard = () => {
    setFlipped(false);
    if (!Array.isArray(flashCardButton) || flashCardButton.length === 0) return;
    setCurrentIndex(
      (prev) => (prev - 1 + flashCardButton.length) % flashCardButton.length
    );
  };
  const lightenColor = (hex, percent = 80) => {
    if (!hex || typeof hex !== "string") return "#f5f5f5";
    let cleanHex = hex.replace("#", "").slice(0, 6);

    const num = parseInt(cleanHex, 16);

    let r = (num >> 16) & 255;
    let g = (num >> 8) & 255;
    let b = num & 255;

    r = Math.round(r + (255 - r) * (percent / 100));
    g = Math.round(g + (255 - g) * (percent / 100));
    b = Math.round(b + (255 - b) * (percent / 100));

    return `rgb(${r}, ${g}, ${b})`;
  };


  async function previousDetails() {
    await fetch(`${baseurl}/summary/previous-attended/`, {
      method: "POST",
      body: JSON.stringify({
        user_id: userDetails && userDetails._id?.$oid,
        topic_id: Topic.id,
        main_topic_id: main_topic_id,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setAssessmentData(data.summary || {});
        } else {
          setAssessmentData({});
        }
      });
  }
  const extractImageFromHtml = (html = "") => {
      const imgRegex = /<img[^>]*>/i;
      const match = html.match(imgRegex);
        
      return {
        imgTag: match ? match[0] : null,
        text: html.replace(imgRegex, "").trim(),
      };
    };


  useEffect(() => {
    Topic_Single();
    hasScrolledToPractice.current = false;
  }, [location.state]);

  useEffect(() => {
    if (!AiId) return;
    dataGet();
    previousDetails();
  }, [AiId]);

  useEffect(() => {
    const userType =
      userStatus === "succeeded" && userDetails && userDetails.user_type;
    setTrailUser(userType === "Trail");
  }, []);

  useEffect(() => {
    if (loading || hasScrolledToPractice.current) return;
    if (scrollToUniqueId == null && scrollToPageNum == null) return;

    const scrollToPracticeBtn = () => {
      const el =
        (scrollToUniqueId && practiceBtnRefs.current[scrollToUniqueId]) ||
        (scrollToPageNum != null &&
          practiceBtnRefs.current[String(scrollToPageNum)]);

      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        hasScrolledToPractice.current = true;
      }
    };

    const timer = setTimeout(scrollToPracticeBtn, 350);
    return () => clearTimeout(timer);
  }, [loading, scrollToPageNum, scrollToUniqueId, topicData]);

const openFlashcardPopup = (cards) => {
  const shuffledCards = Array.isArray(cards) ? [...cards] : [];
  // Shuffle only the member's display copy so the saved/API order stays intact.
  for (let index = shuffledCards.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [shuffledCards[index], shuffledCards[randomIndex]] = [
      shuffledCards[randomIndex],
      shuffledCards[index],
    ];
  }
  setFlashCardButton(shuffledCards);
  setCurrentIndex(0);
  setFlipped(false);
  setFlashCard(true);
  setFlashInputValues({});
  setFlashInputErrors({});
  setFlashInputResults({});
};

const closeFlashcardPopup = () => {
  setFlashCard(false);
  setFlipped(false);
  setFlashCardButton([]);
  setCurrentIndex(0);
  setFlashInputValues({});
  setFlashInputErrors({});
  setFlashInputResults({});
};

  const handleFlashInputChange = (flashcardId, value) => {
    setFlashInputValues((prev) => ({ ...prev, [flashcardId]: value }));
    setFlashInputErrors((prev) => ({ ...prev, [flashcardId]: false }));
  };

  const submitFlashInputCard = (card) => {
    const id = card?.flashcard_id;
    if (!id) return false;

    const userValue = (flashInputValues[id] ?? "").toString();
    const trimmed = userValue.trim();

    if (!trimmed) {
      setFlashInputErrors((prev) => ({
        ...prev,
        [id]: true,
      }));
      return false;
    }

    const userNorm = normalizeAnswer(trimmed);
    const correctNorm = normalizeAnswer(card?.answer);
    const isCorrect = Boolean(correctNorm) && userNorm === correctNorm;

    setFlashInputResults((prev) => ({
      ...prev,
      [id]: { isCorrect },
    }));

    return true;
  };


  return (
    <div className={style.container}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={style.learningBody}>
            <div
              className={style.header}
              style={{ background: trialUser ? "#FF8800" : "" }}
            >
              <div className={style.headerIcon}>
                <img
                  onClick={(e) => {
                    navigate("/new/learnings", {
                      state: {
                        tab: "all-skills",
                        returnFromLearnOrSkill: true,
                        expandedModuleIndices,
                        scrollToModuleIndex,
                      },
                    });
                  }}
                  src={LeftArrow}
                  alt="Left"
                />
              </div>
              <div className={style.headerText}>
                <span>Lesson</span>
                <h4>
                  {topicNo ? `Topic ${topicNo}: ` : ""}
                  {Topic.value.replace(/^Topic \d+:\s*/, "")}
                </h4>
              </div>
            </div>

            {Object.keys(topicData).length === 0 && !loading ? (
              <div className={style.info}>
                <p></p>
              </div>
            ) : (
              <div className={style.learningContainer}>
                <div className={style.learningSection}>
                  <div className={style.learningContent}>
                    {Array.isArray(topicData.pages) &&
                      topicData.pages.length > 0 &&
                      topicData.pages.map((page, idx) => (
                        <div
                          className={style.pageContainer}
                          key={idx}
                          style={{
                            marginBottom: "1em",
                            background: page.selected_color || undefined,
                            borderRadius: "16px",
                            padding: "1rem 2rem 0 2rem",
                            border:
                              page.selected_color === "#ffffff" ||
                              page.selected_color === "#FFFFFF" ||
                              page.selected_color === ""
                                ? "1px solid #00000040"
                                : "none",
                          }}
                        >
                          {page.title ? <h2 style={{paddingTop:"0.2rem"}}>{page.title}</h2> : null}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: cleanHtml(page.text || ""),
                            }}
                          ></div>
                          {page.sub_content &&
                            page.sub_content.trim() !== "" &&
                            (!expandedPages[idx] ? (
                              <div className={style.expandedPages}>
                                <button
                                  className={style.learnMoreBtn}
                                  onClick={() =>
                                    setExpandedPages((prev) => ({
                                      ...prev,
                                      [idx]: true,
                                    }))
                                  }
                                >
                                  Learn more{" "}
                                  <IoChevronDownOutline
                                    className={style.moreicon}
                                  />
                                </button>
                              </div>
                            ) : (
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: cleanHtml(page.sub_content || ""),
                                  }}
                                  style={{
                                    marginTop: "0.5em",
                                    marginBottom: "0.5em",
                                  }}
                                ></div>
                                <div className={style.expandedPages}>
                                 
                                  <button
                                    className={style.learnMoreBtn}
                                    onClick={() =>
                                      setExpandedPages((prev) => ({
                                        ...prev,
                                        [idx]: false,
                                      }))
                                    }
                                  >
                                    Show less{" "}
                                    <IoChevronUpOutline
                                      className={style.moreicon}
                                    />
                                  </button>
                                </div>
                              </>
                            ))}

                          {(page.enable_practice_video ||
                            page.enable_practice || (Array.isArray(page.flash_card) && page.flash_card.length > 0)) && (
                            <div 
                              className={style.actionButtons}
                              style={{
                                marginBottom: !page.sub_content || page.sub_content.trim() === "" ? '0.5rem' : '0'
                              }}
                            >
                              {page.enable_practice_video && (
                                <button
                                  className={style.watchBtn}
                                  onClick={() => {
                                    setVideoUrl(page.practice_video_url);
                                    setVideoPlaybackFailed(false); // Reset fallback state for new video
                                    setShowVideo(true);
                                  }}
                                >
                                  <FaPlay />
                                  Watch
                                </button>
                              )}
                              {page.enable_practice && (
                                <button
                                  ref={(el) => {
                                    if (el) {
                                      if (page.unique_id != null) {
                                        practiceBtnRefs.current[page.unique_id] = el;
                                      }
                                      if (page.page_num != null) {
                                        practiceBtnRefs.current[String(page.page_num)] = el;
                                      }
                                    }
                                  }}
                                  className={style.practiceBtn}
                                  onClick={() => {
                                    console.log("Navigating from NewLearningDetail to /skill/list");
                                    navigate("/skill/list", {
                                      state: {
                                        pageNum: page.page_num, // page_num
                                        title: page.title, // title
                                        uniqueId: page.unique_id, // unique_id
                                        aiId: AiId, // <-- add AiId here
                                        main_topic_id: topicData?.main_topic_id,
                                        topic_id: topicData?.topic_id,
                                        singleTopic: Topic,
                                        learning: learning_id,
                                        mapped: admin_Mapped_Lessons,
                                        mainId: main_topic_id,
                                        topic_no: topicNo,
                                        userID: userID,
                                        orgID: orgID,
                                        fromNewLearningDetail: true,
                                        expandedModuleIndices,
                                        scrollToModuleIndex,
                                        scrollToPageNum: page.page_num,
                                        scrollToUniqueId: page.unique_id,
                                      },
                                    })
                                  }}
                                >
                                  Exercises
                                </button>
                              )}
                              {Array.isArray(page.flash_card) && page.flash_card.length > 0 && (
                              <button
                                className={style.flashCardBtn}
                                onClick={() => openFlashcardPopup(page.flash_card)}
                              >
                                <img
                                  src={flashCardImg}
                                  alt="flashcard"
                                  className={style.flashCardImg}
                                />
                                Flashcards
                              </button>
                              )}
                            </div>
                          )}
                          

               {flashCard && idx === 0 && (
  <>
    <div className={style.popupOverlay}></div>
    <div className={style.flashcardPopup}>
      {cardsToRender.map(({ card, realIndex }) => {
        const offset = realIndex  - currentIndex;
        const visibleOffset = offset < -2 ? -2 : offset > 2 ? 2 : offset;
        const isActive = realIndex  === currentIndex;
        // const isMobile = window.innerWidth <= 768;
        // const translateX = isMobile ? 0 : visibleOffset * 120;
        const translateX = isMobile ? 0 :visibleOffset * 120;
        const scale = 1;
        const rotate = 0;

        return (
          <div
            key={card.flashcard_id}
            className={`${style.flashcard} ${
              isActive ? style.activeCard : ""
            } ${flipped && isActive ? style.flipped : ""}`}
            style={{
              transform: `translateX(${translateX}px) scale(${scale}) rotate(${rotate}deg)`,
              zIndex: 1000 - Math.abs(visibleOffset),
              border: `2px solid ${card.color || "white"}`,
              // opacity: Math.abs(visibleOffset) > 2 ? 0 : 1,
            }}
              onClick={() => {
                if (!isActive) {
                setCurrentIndex(realIndex); 
                setFlipped(false);
              } 
              // else {
              //   setFlipped((prev) => !prev);
              // }
              }}
          >
            {isActive && flashCardButton.length > 1 && (
  <>
    {/* LEFT – Previous card */}
    <button
      className={style.navArrowLeft}
      onClick={(e) => {
        e.stopPropagation();
        setFlipped(false);
        setCurrentIndex(
          (prev) =>
            (prev - 1 + flashCardButton.length) % flashCardButton.length
        );
      }}
    >
      <MdKeyboardArrowRight
        style={{ transform: "rotate(180deg)" }}
      />
    </button>

    {/* RIGHT – Next card */}
    <button
      className={style.navArrowRight}
      onClick={(e) => {
        e.stopPropagation();
        setFlipped(false);
        setCurrentIndex(
          (prev) => (prev + 1) % flashCardButton.length
        );
      }}
    >
      <MdKeyboardArrowRight />
    </button>
  </>
)}

            <div
              className={`${style.cardInner} ${
                flipped && isActive ? style.flipped : ""
              }`}
            >
              <div
                className={`${style.cardFace} ${style.frontFace} ${
                  card?.card_type === "question"
                    ? style.questionFrontFace
                    : style.defaultFrontFace
                }`}
                style={
                  card?.card_type === "question"
                    ? {
                      background: card.color || "#00bcd4",
                      "--question-light-color": lightenColor(card.color, 75),
                      "--question-border-color": card.color || "#22b6de",                       
                      }
                    : { backgroundColor: lightenColor(card.color, 75) }
                }
              >
                
                {isActive && ( <span className={style.flashClose} onClick={closeFlashcardPopup} > X </span> )}
              {(() => {
                const { imgTag, text } = extractImageFromHtml(card.title);
                return (
                  <>
                    {card?.card_type === "question" ? (
                      <>
                        <p
                          className={`${style.cardTitle} ${style.questionCardTitle}`}
                          dangerouslySetInnerHTML={{ __html: text }}
                        ></p>
                        <div className={`${style.flashImgWrapper} ${style.questionFlashImgWrapper}`}>
                          <div className={style.questionImageCircle}>
                            {imgTag ? (
                              <div dangerouslySetInnerHTML={{ __html: imgTag }} />
                            ) : (
                              <img src={flashimg} alt="flash" />
                            )}
                          </div>
                        </div>
                        <div
                          className={`${style.flashInputSection} ${style.questionInputSection}`}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className={style.flashInputWrap}>
                            <input
                              className={`${style.flashInput} ${style.questionFlashInput} ${
                                flashInputErrors[card.flashcard_id]
                                  ? style.flashInputErrorState
                                  : flashInputResults?.[card.flashcard_id]?.isCorrect === true
                                    ? style.flashInputCorrectState
                                    : flashInputResults?.[card.flashcard_id]?.isCorrect === false
                                      ? style.flashInputWrongState
                                      : ""
                              }`}
                              value={flashInputValues[card.flashcard_id] ?? ""}
                              onChange={(e) =>
                                handleFlashInputChange(card.flashcard_id, e.target.value)
                              }
                              placeholder="Answer here"
                            />
                            {flashInputResults?.[card.flashcard_id]?.isCorrect === true ? (
                              <div className={`${style.flashAnswerMark} ${style.flashAnswerMarkCorrect}`}>
                                ✓
                              </div>
                            ) : flashInputResults?.[card.flashcard_id]?.isCorrect === false ? (
                              <div className={`${style.flashAnswerMark} ${style.flashAnswerMarkWrong}`}>
                                ✕
                              </div>
                            ) : null}
                          </div>
                          <div className={`${style.flashbtnContainer} ${style.questionSubmitWrap}`}>
                            <button
                              type="button"
                              className={`${style.flashSubmitBtn} ${style.questionSubmitBtn}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                submitFlashInputCard(card);
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={style.flashImgWrapper}>
                          {imgTag ? (
                            <div dangerouslySetInnerHTML={{ __html: imgTag }} />
                          ) : (
                            <img src={flashimg} alt="flash" />
                          )}
                        </div>
                        <p
                          className={`${style.cardTitle} ${style.defaultCardTitle}`}
                          dangerouslySetInnerHTML={{ __html: text }}
                        ></p>
                      </>
                    )}

                  </>
                );
              })()}

                {/* <p className={style.cardTitle}  style={{ fontWeight: '590' ,fontSize: '1.25rem'}}>{card.title}</p> */}
                  {/* <img src={flashimg} alt="card"  className={style.flashImg}/> */}
                  <div className={style.bottomCard} style={{backgroundColor:card.color ||"white"}}>
                    <button
                      className={style.arrowBtn}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (card?.card_type === "question") {
                          const res = flashInputResults?.[card?.flashcard_id];
                          if (!res) {
                            const currentValue = (flashInputValues?.[card?.flashcard_id] ?? "")
                              .toString()
                              .trim();
                            // Always allow flip even with empty input.
                            if (!currentValue) {
                              setFlipped((prev) => !prev);
                              return;
                            }
                            submitFlashInputCard(card);
                            setFlipped(true);
                            return;
                          }
                          setFlipped((prev) => !prev);
                          return;
                        }
                        setFlipped((prev) => !prev);
                        //  const nextIndex =
                        //     currentIndex + 1 < flashCardButton.length
                        //       ? currentIndex + 1
                        //       : 0;
                      
                        //   setFlipped(false);
                        //   setCurrentIndex(nextIndex);
                      }}
                    >
                      {/* <MdKeyboardArrowRight
                        style={{color:"white",width:"50px",height:"50px",fontSize:"1px"}}
                      /> */}
                      <RiArrowRightSLine
                        style={{color:"white",width:"50px",height:"50px",fontSize:"1px"}}
                       />
                    </button>
                  </div>
              </div>

              <div className={`${style.cardFace} ${style.backFace}`}>
                {isActive && (
                  <span className={style.flashClose} onClick={closeFlashcardPopup}>
                    {" "}
                    X{" "}
                  </span>
                )}
                {/* <p className={style.cardDesc}>{card.description}</p> */}
                <div
              className={style.cardDesc}
              dangerouslySetInnerHTML={{
                __html:
                  card.description || "",
              }}></div>
              <div className={style.bottomCard} style={{backgroundColor:card.color ||"white"}}>
                 <button
                    className={style.arrowBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      setFlipped((prev) => !prev);
                    }}
                  >
                    <MdKeyboardArrowRight
                      style={{
                        color: "white",
                        fontSize:"3rem",
                        transform: "rotate(180deg)"
                      }}
                    />
                  </button>
              </div>
              </div>
            </div>
          </div>
        );
      })}
      <div className={style.controlsWrapper}>
          {flashCardButton.length > 0 && (
            <div className={style.controls}>
              <div className={style.pageIndicator}>
                {currentIndex + 1} / {flashCardButton.length}
              </div>
            </div>
          )}
          <div className={style.closeBelowDots}>
            <button
              className={style.closeBottomBtn}
              onClick={closeFlashcardPopup}
            >
              Close
            </button>
          </div>
        </div>
        
            </div>
          </>
        )}

                          
                        </div>
                      ))}
                  </div>

                  <div className={style.assessmentFloatingSection}>
                    <div className={style.floatingSectionLeft}>
                      <span>Previous Score:</span>
                      <p>
                        {assessmentData?.correct_answers || 0}/
                        {assessmentData?.total_questions || 0}
                      </p>
                    </div>

                    <div className={style.floatingSectionRight}>
                      {!trialUser ? (
                        assessmentData?.is_attended ? (
                          <button
                            disabled={!assessmentExist}
                            style={{ backgroundColor: "#FFBE00" }}
                            onClick={() =>
                              navigate("/assessments", {
                                state: {
                                  aiID: AiId,
                                  singleTopic: Topic,
                                  mapped: admin_Mapped_Lessons,
                                  learning: learning_id,
                                  mainID: main_topic_id,
                                  topicNo: topicNo,
                                },
                              })
                            }
                          >
                            Re-take the Topic Test
                          </button>
                        ) : (
                          <button
                            disabled={!assessmentExist}
                            onClick={() =>
                              navigate("/assessments", {
                                state: {
                                  aiID: AiId,
                                  singleTopic: Topic,
                                  mapped: admin_Mapped_Lessons,
                                  learning: learning_id,
                                  mainID: main_topic_id,
                                  topicNo: topicNo,
                                },
                              })
                            }
                          >
                            Take the Topic Test
                          </button>
                        )
                      ) : assessmentData?.is_attended ? (
                        <button
                          disabled={!assessmentExist}
                          style={{ backgroundColor: "#FFBE00" }}
                          onClick={() =>
                            setSnack({
                              open: true,
                              message: "Subscribe to retake this test",
                            })
                          }
                        >
                          Re-take the Topic Test
                        </button>
                      ) : (
                        <button
                          disabled={!assessmentExist}
                          onClick={() =>
                            navigate("/assessments", {
                              state: {
                                aiID: AiId,
                                singleTopic: Topic,
                                mapped: admin_Mapped_Lessons,
                                learning: learning_id,
                                mainID: main_topic_id,
                                topicNo: topicNo,
                              },
                            })
                          }
                        >
                          Take a Test
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ✅ Video Modal */}
          {showVideo && <VideoModal />}
        </>
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snack.open}
        sx={{ width: "25rem" }}
        autoHideDuration={3000}
        onClose={() => setSnack({ open: false, message: "" })}
      >
        <Alert
          severity="warning"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          {snack.message || ""}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NewLearningDetail;
